.x6ldah0.cape-combobox-list {
  width: max-content;
  min-width: 100%;
  inset-inline-start: auto;
  inset-inline-end: 0;
}